import { render } from "./ListPoint.vue?vue&type=template&id=3ce66c88&scoped=true"
import script from "./ListPoint.vue?vue&type=script&lang=js"
export * from "./ListPoint.vue?vue&type=script&lang=js"

import "./ListPoint.vue?vue&type=style&index=0&id=3ce66c88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce66c88"]])

export default __exports__